import { render, staticRenderFns } from "./TechSupport.vue?vue&type=template&id=22a40e92&scoped=true&"
import script from "./TechSupport.vue?vue&type=script&lang=js&"
export * from "./TechSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a40e92",
  null
  
)

export default component.exports